enum OfferTypes {
  Default = 'default',
  SimilarProducts = 'similarProducts',
  TopOffer = 'topOffer',
  BestOffer = 'bestOffer',
  Landing = 'landing',
  Cashback = 'cashback',
  Selection = 'selection',
}

export default OfferTypes;
